export interface ISource {
  id: number;
  description: string;
  name: string;
  isUserSaved: boolean;
  thumbnail: string;
  logo: string;
  type: string;
}

export interface ISourceBackend {
  id: number;
  description: string;
  is_user_saved: boolean;
  name: string;
  thumbnail: string;
  logo: string;
  source_type: string;
}

export interface IUserSourceBackend {
  id: number;
  source: ISourceBackend;
  created_at: string;
  is_selected: boolean;
  updated_at: string;
  user: number;
}

export interface IUserSource {
  id: number;
  source: ISource;
  createdAt: string;
  isSelected: boolean;
  updatedAt: string;
  user: number;
}

export const createUserSource = (
  userSource: IUserSourceBackend
): IUserSource => {
  return {
    id: userSource.id,
    source: createSource(userSource.source),
    createdAt: userSource.created_at,
    updatedAt: userSource.updated_at,
    user: userSource.user,
    isSelected: userSource ? userSource.is_selected : false,
  };
};

export const createSource = (source: ISourceBackend): ISource => {
  return {
    id: source.id,
    description: source.description,
    name: source.name,
    thumbnail: source.thumbnail,
    logo: source.thumbnail,
    isUserSaved: source.is_user_saved,
    type: source.source_type,
  };
};
